/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AuthService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a session
     * @returns any Authenticated
     * @throws ApiError
     */
    public login({
        requestBody,
    }: {
        requestBody?: ({
            password: string;
        } | {
            user_id: string;
            pin: string;
        }),
    }): CancelablePromise<{
        session_token: string;
        user: {
            id: string;
            name?: string;
            role: 'owner' | 'user';
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Invalid credentials`,
                423: `Account locked`,
            },
        });
    }
    /**
     * Read the current session
     * @returns any Current session
     * @throws ApiError
     */
    public getSession(): CancelablePromise<({
        authenticated: boolean;
        user: {
            id: string;
            name?: string;
            role: 'owner' | 'user';
        };
    } | {
        authenticated: boolean;
    })> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/auth/session',
        });
    }
    /**
     * Clear the current session
     * @returns any Logged out
     * @throws ApiError
     */
    public logout(): CancelablePromise<{
        success: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth/logout',
        });
    }
}
